// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Pitches_Class from "../Data.Pitches.Class/index.js";
import * as Data_Pitches_Spelled from "../Data.Pitches.Spelled/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as ProtoVoices_Common from "../ProtoVoices.Common/index.js";
import * as ProtoVoices_Model from "../ProtoVoices.Model/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var bind = /* #__PURE__ */ Control_Bind.bind(Control_Bind.bindArray);
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(Control_Applicative.applicativeArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "ids";
    }
});
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "passing";
    }
});
var regularIsSymbol = {
    reflectSymbol: function () {
        return "regular";
    }
};
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "unexplained";
    }
});
var showRecord1 = /* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "pitch";
    }
})(/* #__PURE__ */ Data_Pitches_Class.showPitch(Data_Pitches_Spelled.notationPitchSInterval)))(Data_Show.showString));
var showArray = /* #__PURE__ */ Data_Show.showArray(showRecord1);
var showRecordFieldsCons2 = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "left";
    }
});
var rightIsSymbol = {
    reflectSymbol: function () {
        return "right";
    }
};
var showRecordFieldsConsNil1 = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(rightIsSymbol);
var showStartStop = /* #__PURE__ */ ProtoVoices_Model.showStartStop(showRecord1);
var showRecord2 = /* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons2(/* #__PURE__ */ showRecordFieldsConsNil1(showStartStop))(showStartStop));
var showMap = /* #__PURE__ */ Data_Map_Internal.showMap(showRecord2);
var showRecordFieldsCons3 = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "child";
    }
});
var showRecordFieldsConsNil2 = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "orn";
    }
});
var showMaybe = /* #__PURE__ */ Data_Maybe.showMaybe(ProtoVoices_Model.showDoubleOrnament);
var showArray1 = /* #__PURE__ */ Data_Show.showArray(showRecord2);
var showRecordFieldsCons4 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(rightIsSymbol);
var showMap1 = /* #__PURE__ */ Data_Map_Internal.showMap(showRecord1);
var LMSplitLeftIsSymbol = {
    reflectSymbol: function () {
        return "LMSplitLeft";
    }
};
var LMFreezeLeftIsSymbol = {
    reflectSymbol: function () {
        return "LMFreezeLeft";
    }
};
var LMSplitRightIsSymbol = {
    reflectSymbol: function () {
        return "LMSplitRight";
    }
};
var LMHorizontalizeIsSymbol = {
    reflectSymbol: function () {
        return "LMHorizontalize";
    }
};
var LMSplitOnlyIsSymbol = {
    reflectSymbol: function () {
        return "LMSplitOnly";
    }
};
var LMFreezeOnlyIsSymbol = {
    reflectSymbol: function () {
        return "LMFreezeOnly";
    }
};
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showRecord1));
var showRecord3 = /* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons2(/* #__PURE__ */ showRecordFieldsConsNil1(showArray))(showArray));
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray)(Data_Either.applicativeEither);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var RootNote = /* #__PURE__ */ (function () {
    function RootNote() {

    };
    RootNote.value = new RootNote();
    return RootNote;
})();
var SplitOp = function (x) {
    return x;
};
var LMSplitLeft = /* #__PURE__ */ (function () {
    function LMSplitLeft(value0) {
        this.value0 = value0;
    };
    LMSplitLeft.create = function (value0) {
        return new LMSplitLeft(value0);
    };
    return LMSplitLeft;
})();
var LMFreezeLeft = /* #__PURE__ */ (function () {
    function LMFreezeLeft(value0) {
        this.value0 = value0;
    };
    LMFreezeLeft.create = function (value0) {
        return new LMFreezeLeft(value0);
    };
    return LMFreezeLeft;
})();
var LMSplitRight = /* #__PURE__ */ (function () {
    function LMSplitRight(value0) {
        this.value0 = value0;
    };
    LMSplitRight.create = function (value0) {
        return new LMSplitRight(value0);
    };
    return LMSplitRight;
})();
var LMHorizontalize = /* #__PURE__ */ (function () {
    function LMHorizontalize(value0) {
        this.value0 = value0;
    };
    LMHorizontalize.create = function (value0) {
        return new LMHorizontalize(value0);
    };
    return LMHorizontalize;
})();
var LMSplitOnly = /* #__PURE__ */ (function () {
    function LMSplitOnly(value0) {
        this.value0 = value0;
    };
    LMSplitOnly.create = function (value0) {
        return new LMSplitOnly(value0);
    };
    return LMSplitOnly;
})();
var LMFreezeOnly = /* #__PURE__ */ (function () {
    function LMFreezeOnly(value0) {
        this.value0 = value0;
    };
    LMFreezeOnly.create = function (value0) {
        return new LMFreezeOnly(value0);
    };
    return LMFreezeOnly;
})();
var LeftChild = /* #__PURE__ */ (function () {
    function LeftChild(value0) {
        this.value0 = value0;
    };
    LeftChild.create = function (value0) {
        return new LeftChild(value0);
    };
    return LeftChild;
})();
var RightChild = /* #__PURE__ */ (function () {
    function RightChild(value0) {
        this.value0 = value0;
    };
    RightChild.create = function (value0) {
        return new RightChild(value0);
    };
    return RightChild;
})();
var BothChildren = /* #__PURE__ */ (function () {
    function BothChildren(value0) {
        this.value0 = value0;
    };
    BothChildren.create = function (value0) {
        return new BothChildren(value0);
    };
    return BothChildren;
})();
var TooManyChildren = /* #__PURE__ */ (function () {
    function TooManyChildren(value0) {
        this.value0 = value0;
    };
    TooManyChildren.create = function (value0) {
        return new TooManyChildren(value0);
    };
    return TooManyChildren;
})();
var HoriOp = function (x) {
    return x;
};
var FreezeOp = function (x) {
    return x;
};
var semigroupHoriChildren = {
    append: function (a) {
        return function (b) {
            if (a instanceof LeftChild) {
                if (b instanceof LeftChild) {
                    return new TooManyChildren({
                        left: [ a.value0, b.value0 ],
                        right: [  ]
                    });
                };
                if (b instanceof RightChild) {
                    return new BothChildren({
                        left: a.value0,
                        right: b.value0
                    });
                };
                if (b instanceof BothChildren) {
                    return new TooManyChildren({
                        left: [ a.value0, b.value0.left ],
                        right: [ b.value0.right ]
                    });
                };
                if (b instanceof TooManyChildren) {
                    return new TooManyChildren({
                        left: Data_Array.cons(a.value0)(b.value0.left),
                        right: b.value0.right
                    });
                };
                throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 105, column 20 - line 109, column 88): " + [ b.constructor.name ]);
            };
            if (a instanceof RightChild) {
                if (b instanceof LeftChild) {
                    return new BothChildren({
                        left: b.value0,
                        right: a.value0
                    });
                };
                if (b instanceof RightChild) {
                    return new TooManyChildren({
                        left: [  ],
                        right: [ a.value0, b.value0 ]
                    });
                };
                if (b instanceof BothChildren) {
                    return new TooManyChildren({
                        left: [ b.value0.left ],
                        right: [ a.value0, b.value0.right ]
                    });
                };
                if (b instanceof TooManyChildren) {
                    return new TooManyChildren({
                        left: b.value0.left,
                        right: Data_Array.cons(a.value0)(b.value0.right)
                    });
                };
                throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 110, column 21 - line 114, column 89): " + [ b.constructor.name ]);
            };
            if (a instanceof BothChildren) {
                if (b instanceof LeftChild) {
                    return new TooManyChildren({
                        left: [ a.value0.left, b.value0 ],
                        right: [ a.value0.right ]
                    });
                };
                if (b instanceof RightChild) {
                    return new TooManyChildren({
                        left: [ a.value0.left ],
                        right: [ a.value0.right, b.value0 ]
                    });
                };
                if (b instanceof BothChildren) {
                    return new TooManyChildren({
                        left: [ a.value0.left, b.value0.left ],
                        right: [ a.value0.right, b.value0.right ]
                    });
                };
                if (b instanceof TooManyChildren) {
                    return new TooManyChildren({
                        left: Data_Array.cons(a.value0.left)(b.value0.left),
                        right: Data_Array.cons(a.value0.right)(b.value0.right)
                    });
                };
                throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 115, column 43 - line 119, column 104): " + [ b.constructor.name ]);
            };
            if (a instanceof TooManyChildren) {
                if (b instanceof LeftChild) {
                    return new TooManyChildren({
                        left: Data_Array.snoc(a.value0.left)(b.value0),
                        right: a.value0.right
                    });
                };
                if (b instanceof RightChild) {
                    return new TooManyChildren({
                        left: a.value0.left,
                        right: Data_Array.snoc(a.value0.right)(b.value0)
                    });
                };
                if (b instanceof BothChildren) {
                    return new TooManyChildren({
                        left: Data_Array.snoc(a.value0.left)(b.value0.left),
                        right: Data_Array.snoc(a.value0.right)(b.value0.right)
                    });
                };
                if (b instanceof TooManyChildren) {
                    return new TooManyChildren({
                        left: append(a.value0.left)(b.value0.left),
                        right: append(a.value0.right)(b.value0.right)
                    });
                };
                throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 120, column 46 - line 124, column 96): " + [ b.constructor.name ]);
            };
            throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 104, column 16 - line 124, column 96): " + [ a.constructor.name ]);
        };
    }
};
var rightEdges = function (splits) {
    return bind(toUnfoldable(splits))(function (v) {
        return bind(v.value1)(function (child) {
            return pure({
                left: new ProtoVoices_Model.Inner(child.child),
                right: v.value0.right
            });
        });
    });
};
var leftEdges = function (splits) {
    return bind(toUnfoldable(splits))(function (v) {
        return bind(v.value1)(function (child) {
            return pure({
                left: v.value0.left,
                right: new ProtoVoices_Model.Inner(child.child)
            });
        });
    });
};
var horiRightChildren = function (v) {
    var unexpl = map(function (note) {
        return {
            note: note,
            expl: ProtoVoices_Model.NoExpl.value
        };
    })(v.unexplained.right);
    var getChild = function (v1) {
        if (v1.value1 instanceof RightChild) {
            return [ {
                note: v1.value1.value0,
                expl: new ProtoVoices_Model.HoriExpl(v1.value0)
            } ];
        };
        if (v1.value1 instanceof LeftChild) {
            return [  ];
        };
        if (v1.value1 instanceof BothChildren) {
            return [ {
                note: v1.value1.value0.right,
                expl: new ProtoVoices_Model.HoriExpl(v1.value0)
            } ];
        };
        if (v1.value1 instanceof TooManyChildren) {
            return map(function (v2) {
                return {
                    note: v2,
                    expl: new ProtoVoices_Model.HoriExpl(v1.value0)
                };
            })(v1.value1.value0.right);
        };
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 154, column 34 - line 158, column 78): " + [ v1.value1.constructor.name ]);
    };
    var explained = Data_Array.concatMap(getChild)(toUnfoldable(v.children));
    return ProtoVoices_Model.sortNotes(append(unexpl)(explained));
};
var horiLeftChildren = function (v) {
    var unexpl = map(function (note) {
        return {
            note: note,
            expl: ProtoVoices_Model.NoExpl.value
        };
    })(v.unexplained.left);
    var getChild = function (v1) {
        if (v1.value1 instanceof LeftChild) {
            return [ {
                note: v1.value1.value0,
                expl: new ProtoVoices_Model.HoriExpl(v1.value0)
            } ];
        };
        if (v1.value1 instanceof RightChild) {
            return [  ];
        };
        if (v1.value1 instanceof BothChildren) {
            return [ {
                note: v1.value1.value0.left,
                expl: new ProtoVoices_Model.HoriExpl(v1.value0)
            } ];
        };
        if (v1.value1 instanceof TooManyChildren) {
            return map(function (v2) {
                return {
                    note: v2,
                    expl: new ProtoVoices_Model.HoriExpl(v1.value0)
                };
            })(v1.value1.value0.left);
        };
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 141, column 34 - line 145, column 76): " + [ v1.value1.constructor.name ]);
    };
    var explained = Data_Array.concatMap(getChild)(toUnfoldable(v.children));
    return ProtoVoices_Model.sortNotes(append(unexpl)(explained));
};
var genericSplitOp = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericRootOrnament = {
    to: function (x) {
        return RootNote.value;
    },
    from: function (x) {
        return Data_Generic_Rep.NoArguments.value;
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericRootOrnament)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
    reflectSymbol: function () {
        return "RootNote";
    }
}));
var showRootOrnament = {
    show: function (ro) {
        return genericShow(ro);
    }
};
var genericShow1 = /* #__PURE__ */ Data_Show_Generic.genericShow(genericSplitOp)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "fromLeft";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "fromRight";
    }
})(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "keepLeft";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "keepRight";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "passLeft";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "passRight";
    }
})(/* #__PURE__ */ showRecordFieldsCons1(/* #__PURE__ */ Data_Show.showRecordFieldsCons(regularIsSymbol)(/* #__PURE__ */ showRecordFieldsConsNil(showArray))(/* #__PURE__ */ showMap(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons3(/* #__PURE__ */ showRecordFieldsConsNil2(/* #__PURE__ */ Data_Either.showEither(showRootOrnament)(showMaybe)))(showRecord1))))))(/* #__PURE__ */ showMap(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons3(/* #__PURE__ */ showRecordFieldsConsNil2(showMaybe))(showRecord1))))))(showArray1))(showArray1))(showArray1))(showArray1))(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons2(/* #__PURE__ */ showRecordFieldsCons4(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "slice";
    }
})(ProtoVoices_Model.showSliceId))(ProtoVoices_Model.showTransId))(ProtoVoices_Model.showTransId))))(/* #__PURE__ */ showMap1(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons3(/* #__PURE__ */ showRecordFieldsConsNil2(/* #__PURE__ */ Data_Maybe.showMaybe(ProtoVoices_Model.showLeftOrnament)))(showRecord1))))))(/* #__PURE__ */ showMap1(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons3(/* #__PURE__ */ showRecordFieldsConsNil2(/* #__PURE__ */ Data_Maybe.showMaybe(ProtoVoices_Model.showRightOrnament)))(showRecord1))))))))({
    reflectSymbol: function () {
        return "SplitOp";
    }
}));
var showSplitOp = {
    show: function (so) {
        return genericShow1(so);
    }
};
var genericLeftmost = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new LMSplitLeft(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new LMFreezeLeft(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new LMSplitRight(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new LMHorizontalize(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new LMSplitOnly(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))) {
            return new LMFreezeOnly(x.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 25, column 1 - line 25, column 62): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof LMSplitLeft) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof LMFreezeLeft) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof LMSplitRight) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof LMHorizontalize) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof LMSplitOnly) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof LMFreezeOnly) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))));
        };
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 25, column 1 - line 25, column 62): " + [ x.constructor.name ]);
    }
};
var genericShow2 = /* #__PURE__ */ Data_Show_Generic.genericShow(genericLeftmost);
var showLeftmost = function (dictShow) {
    var genericShowConstructor1 = Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow));
    var genericShowSum = Data_Show_Generic.genericShowSum(genericShowConstructor1(LMSplitLeftIsSymbol));
    var genericShowSum1 = Data_Show_Generic.genericShowSum(genericShowConstructor1(LMSplitRightIsSymbol));
    var genericShowSum2 = Data_Show_Generic.genericShowSum(genericShowConstructor1(LMSplitOnlyIsSymbol));
    return function (dictShow1) {
        var genericShowConstructor2 = Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow1));
        var genericShowSum3 = Data_Show_Generic.genericShowSum(genericShowConstructor2(LMFreezeLeftIsSymbol));
        var genericShowSum4 = genericShowSum2(genericShowConstructor2(LMFreezeOnlyIsSymbol));
        return function (dictShow2) {
            var genericShow6 = genericShow2(genericShowSum(genericShowSum3(genericShowSum1(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow2))(LMHorizontalizeIsSymbol))(genericShowSum4)))));
            return {
                show: function (lm) {
                    return genericShow6(lm);
                }
            };
        };
    };
};
var genericHoriOp = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericHoriChildren = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new LeftChild(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new RightChild(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new BothChildren(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return new TooManyChildren(x.value0.value0.value0);
        };
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 177, column 1 - line 177, column 62): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof LeftChild) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof RightChild) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof BothChildren) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof TooManyChildren) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
        };
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 177, column 1 - line 177, column 62): " + [ x.constructor.name ]);
    }
};
var genericShow3 = /* #__PURE__ */ Data_Show_Generic.genericShow(genericHoriChildren)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "LeftChild";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "RightChild";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons2(/* #__PURE__ */ showRecordFieldsConsNil1(showRecord1))(showRecord1))))({
    reflectSymbol: function () {
        return "BothChildren";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showRecord3))({
    reflectSymbol: function () {
        return "TooManyChildren";
    }
})))));
var showHoriChildren = {
    show: function (hc) {
        return genericShow3(hc);
    }
};
var genericShow4 = /* #__PURE__ */ Data_Show_Generic.genericShow(genericHoriOp)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "children";
    }
})(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "midEdges";
    }
})(/* #__PURE__ */ showRecordFieldsConsNil(showRecord3))(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons1(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(regularIsSymbol)(/* #__PURE__ */ Data_Set.showSet(showRecord2)))(showArray1))))(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons2(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "lslice";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "mid";
    }
})(/* #__PURE__ */ showRecordFieldsCons4(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "rslice";
    }
})(ProtoVoices_Model.showSliceId))(ProtoVoices_Model.showTransId))(ProtoVoices_Model.showTransId))(ProtoVoices_Model.showSliceId))(ProtoVoices_Model.showTransId))))(/* #__PURE__ */ showMap1(showHoriChildren)))))({
    reflectSymbol: function () {
        return "HoriOp";
    }
}));
var showHoriOp = {
    show: function (ho) {
        return genericShow4(ho);
    }
};
var genericFreezeOp = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericShow5 = /* #__PURE__ */ Data_Show_Generic.genericShow(genericFreezeOp)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "prevTime";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "ties";
    }
})(showArray1))(/* #__PURE__ */ Data_Either.showEither(Data_Show.showString)(ProtoVoices_Common.showMBS)))))({
    reflectSymbol: function () {
        return "FreezeOp";
    }
}));
var showFreezeOp = {
    show: function (fo) {
        return genericShow5(fo);
    }
};
var extractChildNotes = function (splits) {
    return function (f) {
        return sequence(bind(toUnfoldable(splits))(function (v) {
            return bind(v.value1)(function (child) {
                return pure((function () {
                    var v1 = f(v.value0)(child.orn);
                    if (v1 instanceof Data_Either.Left) {
                        return new Data_Either.Left(v1.value0);
                    };
                    if (v1 instanceof Data_Either.Right) {
                        return new Data_Either.Right({
                            note: child.child,
                            expl: v1.value0
                        });
                    };
                    throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 68, column 10 - line 70, column 54): " + [ v1.constructor.name ]);
                })());
            });
        }));
    };
};
var splitGetChildNotes = function (v) {
    return bind1(extractChildNotes(v.regular)(function (p) {
        return function (o) {
            if (o instanceof Data_Either.Left) {
                return new Data_Either.Right(ProtoVoices_Model.RootExpl.value);
            };
            if (o instanceof Data_Either.Right) {
                if (p.left instanceof ProtoVoices_Model.Inner) {
                    if (p.right instanceof ProtoVoices_Model.Inner) {
                        return new Data_Either.Right(new ProtoVoices_Model.DoubleExpl({
                            leftParent: p.left.value0,
                            rightParent: p.right.value0,
                            orn: o.value0
                        }));
                    };
                    return new Data_Either.Left("Parent note cannot be Start or Stop!");
                };
                return new Data_Either.Left("Parent note cannot be Start or Stop!");
            };
            throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 75, column 41 - line 81, column 57): " + [ o.constructor.name ]);
        };
    }))(function (regular) {
        return bind1(extractChildNotes(v.passing)(function (p) {
            return function (orn) {
                if (p.left instanceof ProtoVoices_Model.Inner) {
                    if (p.right instanceof ProtoVoices_Model.Inner) {
                        return new Data_Either.Right(new ProtoVoices_Model.DoubleExpl({
                            leftParent: p.left.value0,
                            rightParent: p.right.value0,
                            orn: orn
                        }));
                    };
                    return new Data_Either.Left("Parent note cannot be Start or Stop!");
                };
                return new Data_Either.Left("Parent note cannot be Start or Stop!");
            };
        }))(function (passing) {
            return bind1(extractChildNotes(v.fromLeft)(function (p) {
                return function (orn) {
                    return new Data_Either.Right(new ProtoVoices_Model.RightExpl({
                        leftParent: p,
                        orn: orn
                    }));
                };
            }))(function (fromLeft) {
                return bind1(extractChildNotes(v.fromRight)(function (p) {
                    return function (orn) {
                        return new Data_Either.Right(new ProtoVoices_Model.LeftExpl({
                            rightParent: p,
                            orn: orn
                        }));
                    };
                }))(function (fromRight) {
                    var unexplained = map(function (note) {
                        return {
                            note: note,
                            expl: ProtoVoices_Model.NoExpl.value
                        };
                    })(v.unexplained);
                    return pure1(ProtoVoices_Model.sortNotes(append(regular)(append(passing)(append(fromLeft)(append(fromRight)(unexplained))))));
                });
            });
        });
    });
};
export {
    LMSplitLeft,
    LMFreezeLeft,
    LMSplitRight,
    LMHorizontalize,
    LMSplitOnly,
    LMFreezeOnly,
    RootNote,
    SplitOp,
    leftEdges,
    rightEdges,
    extractChildNotes,
    splitGetChildNotes,
    FreezeOp,
    LeftChild,
    RightChild,
    BothChildren,
    TooManyChildren,
    HoriOp,
    horiLeftChildren,
    horiRightChildren,
    genericLeftmost,
    showLeftmost,
    semigroupHoriChildren,
    genericRootOrnament,
    showRootOrnament,
    genericSplitOp,
    showSplitOp,
    genericFreezeOp,
    showFreezeOp,
    genericHoriChildren,
    showHoriChildren,
    genericHoriOp,
    showHoriOp
};
